import { type FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonClose, ButtonWithArray } from '@/components/buttons';
import { Modals } from '@/helpers/modals';
import { useGameProviders } from '@/hooks/game';
import { useNavigation } from '@/hooks/navigation';
import { useModalsStore } from '@/store';

import { ScProvidersSelect } from './styled';

export interface IProvidersProps {
  providerId?: string;
}

export const Providers: FC<IProvidersProps> = ({ providerId }) => {
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  const open = useModalsStore.use.open();

  const { pendingProviders, currentProvider } = useGameProviders({
    providerId,
  });

  const handleModalOpen = useCallback(() => {
    open(Modals.Providers);
  }, [open]);

  const resetProvider = () => {
    navigate('/', true);
  };

  return (
    <ScProvidersSelect>
      <ButtonWithArray
        disabled={pendingProviders}
        onClick={handleModalOpen}
        selected={!!currentProvider}
      >
        {currentProvider?.title || t('allProviders')}
      </ButtonWithArray>
      {currentProvider && (
        <ButtonClose
          className="close"
          onClick={resetProvider}
          right={4}
          top={0}
        />
      )}
    </ScProvidersSelect>
  );
};
